module.exports = __webpack_public_path__ + "static/img/Nathanial-Atkinson.7b80325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathanial-Atkinson.jpg
// module id = iW62
// module chunks = 0